import getLocal from '@/app/utils/getLocal';
import classNames from 'classnames';
import EfImg from 'elem/ui/ef-img';
import './index.scss';
import { OutPutIcon, TimeIcon } from '../../icons';
import React from 'react';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';

export interface EfCardCartItemProps {
    /**
     * 产品 productId
     */
    productId?: string;
    /**
     * 产品 variantId
     */
    variantId?: string;
    /**
     * 默认购买数量
     */
    quantity?: number;
    /**
     * 库存
     */
    inventory: number;
    /**
     * 所有分辨率展示的资源链接
     */
    img?: string;
    /**
     * tag
     */
    tab1?: string;
    tab2?: string;
    /**
     * 主标题
     */
    title: string;
    /**
     * label描述文案
     */
    label?: string;
    /**
     * 描述
     */
    desc?: string;
    /**
     * 产品原始价格
     */
    originalPrice?: number;
    /**
     * 产品折后价格
     */
    discountPrice?: number;
    /**
     * btnCartText
     */
    btnCartText?: string;
}

export interface EfCardCartListsProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * gtm list name
     */
    list_name?: string;
    /**
     * 商品列表
     */
    items?: EfCardCartItemProps[];
    /**
     * callbackCart
     */
    callbackCart?: any;
}

/**
 * 商品卡片列表
 */
const EfCardCartLists: React.FC<EfCardCartListsProps> = ({ items, className, list_name, callbackCart }) => {
    const prefixCls = `ef-card-cart-lists`;
    const prefix = `${prefixCls}-`;
    const { locale } = getLocal();

    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });

    return (
        <div className={classes}>
            <div className={`${prefix}cards-box`}>
                <ul className={`${prefix}cards`}>
                    {items?.map((item: EfCardCartItemProps, k: number) => (
                        <li className={`${prefix}card`} key={k}>
                            <div className={`${prefix}card-img`}>
                                <EfImg pc={item.img} />
                            </div>
                            <div className={`${prefix}card-info`}>
                                {item?.label && <p className={`${prefix}info-label`}>{item?.label}</p>}
                                {item?.title && <p className={`${prefix}info-title`}>{item?.title}</p>}
                                {item?.desc && <p className={`${prefix}info-desc`}>{item?.desc}</p>}
                            </div>
                            <div className={`${prefix}card-tab`}>
                                {item?.tab1 && (
                                    <p className={`${prefix}tab1`}>
                                        <TimeIcon />
                                        {item?.tab1}
                                    </p>
                                )}
                                {item?.tab2 && (
                                    <p className={`${prefix}tab2`}>
                                        <OutPutIcon />
                                        {item?.tab2}
                                    </p>
                                )}
                            </div>
                            <div className={`${prefix}card-footer`}>
                                <button
                                    className={`GtmModuleData-btn-href ${prefix}card-add-cart${item?.inventory <= 0 ? ' disable' : ''}`}
                                    onClick={() => callbackCart(item, list_name)}
                                >
                                    {item?.btnCartText}
                                </button>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={`${prefixCls}-container`}>
                <Swiper
                    modules={[Pagination]}
                    pagination={{
                        clickable: true,
                    }}
                    navigation={false}
                    className="card-swiper"
                    slidesPerView="auto"
                    spaceBetween={16}
                >
                    {items?.map((item, k) => (
                        <SwiperSlide className="swiper-item" key={k}>
                            <li className={`${prefix}card`} key={k}>
                                <div className={`${prefix}card-img`}>
                                    <EfImg pc={item.img} />
                                </div>
                                <div className={`${prefix}card-info`}>
                                    {item?.label && <p className={`${prefix}info-label`}>{item?.label}</p>}
                                    {item?.title && <p className={`${prefix}info-title`}>{item?.title}</p>}
                                    {item?.desc && <p className={`${prefix}info-desc`}>{item?.desc}</p>}
                                </div>
                                <div className={`${prefix}card-tab`}>
                                    {item?.tab1 && (
                                        <p className={`${prefix}tab1`}>
                                            <TimeIcon />
                                            {item?.tab1}
                                        </p>
                                    )}
                                    {item?.tab2 && (
                                        <p className={`${prefix}tab2`}>
                                            <OutPutIcon />
                                            {item?.tab2}
                                        </p>
                                    )}
                                </div>
                                <div className={`${prefix}card-footer`}>
                                    <button
                                        className={`${prefix}card-add-cart${item?.inventory <= 0 ? ' disable' : ''}`}
                                        onClick={() => callbackCart(item, list_name)}
                                    >
                                        {item?.btnCartText}
                                    </button>
                                </div>
                            </li>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default EfCardCartLists;
